import BubbleCommon from '@op/components/BubbleCommon';
import React from 'react';
import { influencerCoreTagsTipsMap } from '../constants';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { useIntl } from 'umi';
import { NO_DATE } from '@op/constants';

interface IInfluencerExtraTags {
  name: string;
  tags: IInfluencerTags[];
  color: string;
  backgroundColor: string;
  text: string;
}

export interface IInfluencerTags {
  cover: string;
  game: string;
  entity_type: string;
}

export const InfluencerExtraTags = (props: IInfluencerExtraTags) => {
  const { name, tags, color, backgroundColor, text } = props;
  const { formatMessage } = useIntl();
  return (
    <BubbleCommon
      tipsMap={influencerCoreTagsTipsMap?.[name]}
      showIcon={false}
      extraContent={
        <>
          {tags?.map(
            (
              data: {
                cover: string;
                game: string;
                entity_type: string;
              },
              i: number,
            ) => (
              <div className={'dbo-game-icon-tag-bubble'} key={i}>
                <RenderGameIcon
                  gameInfo={{
                    entity_type: data?.entity_type,
                    cover: data?.cover,
                    edition_unified_id: String(i),
                  }}
                ></RenderGameIcon>
                <span>{data.game}</span>
              </div>
            ),
          )}
        </>
      }
      childClassName={'tag-item'}
    >
      <div
        className={'tea-tag tag-item dbo-game-icon-tag'}
        style={{ color, backgroundColor }}
      >
        {tags?.slice(0, 4).map((data, i) => {
          return (
            <RenderGameIcon
              gameInfo={{
                entity_type: data?.entity_type,
                cover: data?.cover,
                edition_unified_id: i + '',
              }}
              key={i}
            ></RenderGameIcon>
          );
        })}
        {/* {tags && tags.length > 4 && (
          <span className="dbo-game-icon-tag-rest">+{tags.length - 4}</span>
        )} */}
        <span title={text || NO_DATE.EMPTY}>
          {text || NO_DATE.EMPTY}
        </span>
      </div>
    </BubbleCommon>
  );
};
